<template>
  <div class="centerx" id="add-more-service">
    <vs-popup class="checkout-service-popup" title="Add Service" :active.sync="popupService.isOpen">
      <div>
        <div class="p-6 w-full" style="position: absolute; top: 0; left: 0">
          <div class="con-input-search vs-table--search m-0 mx-3" style="max-width: unset">
            <input type="text" class="input-search vs-table--search-input rounded-item border-custom w-full py-3 text-sm" @input="searchService" placeholder="Search service...">
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
          </div>
        </div>
        <div class="border-top-custom popup-service-scroll" style="max-height: calc(100vh - 310px); overflow-y: auto; margin-top: 85px" v-if="popupService.item_info">
          <!-- <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(service, index) in serviceList" :key="index">
            <template slot="no-body">
                <div class="item-details no-gutter p-6 flex align-center">
                  <div class="w-11/12">{{service.name}}</div>
                   <div class="1/12 ml-auto vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                      <input class="vs-checkbox--input" type="checkbox" v-model="checkBoxService" :id="service.id" :value="service.id" @change="onChangeService">
                      <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                        <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                      </span>
                    </div>
                </div>
            </template>
          </vx-card>
          <div v-if="serviceData._meta.pageCount > 1">
            <vs-pagination class="mt-6 custom-pagination" :total="parseInt(serviceData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination>
          </div> -->
          <!-- <div v-if="search == ''">
            <div v-for="(cate, index) in serviceListByCate" :key="index">
              <div v-if="cate.id && cate.services.length > 0">
                <h3 class="px-base my-6">{{cate.name}}</h3>
                <ul class="w-full service-list border-bottom-custom">
                  <span v-for="(service, i) in cate.services" :key="i" @click="selectService(service)">
                    <li class="p-6 border-top-custom service-item" v-if="!isInCurrentCheckin(service)">
                      {{service.name}}
                    </li>
                  </span>
                </ul>
              </div>
            </div>
          </div> -->

          <div v-if="type=='checkout' && serviceListWithSearch.length > 0 && !noData(serviceListWithSearch)">
            <div v-for="(cate, index) in serviceListWithSearch" :key="index">
              <div v-if="cate.id && cate.services.length > 0 && !isAllChosen(cate.services)">
                <h3 class="px-base my-6 font-bold">{{cate.name}}</h3>
                <ul class="w-full service-list border-bottom-custom" :style="getBorderLeftColor(cate)">
                  <span v-for="(service, i) in cate.services" :key="i" @click="selectService(service)">
                    <li class="p-6 border-top-custom service-item cursor-pointer" v-if="!isInCurrentCheckin(service)">
                      {{service.name}}
                      <span v-if="service.price!=null" class="float-right">${{service.price}}</span>
                      <span v-else class="float-right">$0.00</span>
                    </li>
                  </span>
                </ul>
              </div>
            </div>
          </div>

          <div v-else-if="type=='appointment' && serviceListWithSearchAppt.length > 0">
            <div v-for="(cate, index) in serviceListWithSearchAppt" :key="index">
              <div v-if="cate.id && cate.services.length > 0">
                <h3 class="px-base my-6 font-bold">{{cate.name}}</h3>
                <ul class="w-full service-list border-bottom-custom" :style="getBorderLeftColor(cate)">
                  <span v-for="(service, i) in cate.services" :key="i" @click="selectService(service)">
                    <li class="p-6 border-top-custom service-item cursor-pointer">
                      {{service.name}}
                      <span v-if="service.price!=null" class="float-right">${{service.price}}</span>
                      <span v-else class="float-right">$0.00</span>
                    </li>
                  </span>
                </ul>
              </div>
            </div>
          </div>

          <div v-else class="flex justify-center" style="margin-top: 85px">No data available</div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import { StringHelper } from "../../models/string_helper";
    export default {
        name: "vs-popup-service",
        // components: {
        //     ListItem: () => import("./ListItem.vue"),
        //     ListRadioItem: () => import("./ListRadioItem.vue"),
        // },
        props: {
            popupService: {
                type: Object,
                required: true
            },
            add_service_temp: {
              type: Array,
              // default: []
            },
            type: {
                type: String,
                default: 'checkout'
            }
        },
        data() {
          // if(this.popupService) {
          //   console.log(this.popupService)
          // }
            return {
                // staff: false,
                // StringHelper,
                // currentPage: 1,
                // itemsPerPage: 10,
                // currentPageStaff: 1,
                // itemsPerPageStaff: 10,
                //  note: '',
                //  promotion: '',
                //  redemption_list: [
                //      {title: '3pts',   content: '$1 off for 3 points', checked: undefined },
                //      {title: '100pts', content: '$5 off for 100 points', checked: undefined },
                //      {title: '300pts', content: '$10 off for 300 points', checked: undefined },
                //      {title: '500pts',   content: '500 points you can get free 30$', checked: undefined },
                //  ],
                //  promotion_list: [
                //      {title: '3pts',   content: '$1 off for 3 points' },
                //      {title: '100pts', content: '$5 off for 100 points' },
                //      {title: '300pts', content: '$10 off for 300 points' },
                //      {title: '500pts',   content: '500 points you can get free 30$' },
                //  ],
                //  checkBoxService: [],
                 search: '',
            }
        },
        // watch:{
        //   popupService: {
        //       immediate: true,
        //       deep: true,
        //       handler() {
        //         if(this.popupService.isOpen == false) {
        //           this.staff = false;
        //           this.currentPage = 1;
        //           this.changePage(this.currentPage, this.itemsPerPage);
        //         }
        //       }
        //   }
        // },
        methods: {
          getBorderLeftColor(cate) {
            if(cate && cate.color_detail && cate.color_detail.color_code) {
              return 'border-left-color: ' + cate.color_detail.color_code + ' !important';
            }
            return '';
          },
          isInCurrentCheckin(service) {
            // if(this.popupService.item_info) {
            //   for(let i = 0; i < this.popupService.item_info.length; i++) {
            //     if(this.popupService.item_info[i].id == service.id) {
            //       return true;
            //     }
            //   }
            // }
            if(this.add_service_temp) {
              for(let i = 0; i < this.add_service_temp.length; i++) {
                if(this.add_service_temp[i].service.id == service.id) {
                  return true;
                }
              }
            }
            return false;
          },
          isAllChosen(services) {
            let count = 0;
            // if(this.popupService.item_info) {
            //   for(let i = 0; i < this.popupService.item_info.length; i++) {
            //     for(let j = 0; j < services.length; j++) {
            //       if(this.popupService.item_info[i].id == services[j].id) {
            //         count++;
            //       }
            //     }
            //   }
            // }
            if(this.add_service_temp) {
              for(let i = 0; i < this.add_service_temp.length; i++) {
                for(let j = 0; j < services.length; j++) {
                  if(this.add_service_temp[i].service.id == services[j].id) {
                    count++;
                  }
                }
              }
            }
            if(count == services.length) {
              return true;
            }
            return false;
          },
          noData(list) {
            let count = 0;
            for(let i = 0; i < list.length; i++) {
              if(list[i].services.length == 0) {
                count++;
              }
            }
            if(count == list.length) {
              return true;
            }
            return false;
          },
          // serviceInCategory(service, cate) {
          //   for(let i = 0; i < cate.services.length; i++) {
          //     if(service.id == cate.services[i].id) {
          //       return true;
          //     }
          //   }
          //   return false;
          // },
          // hasServiceNotSelected(cate) {
          //   if(this.popupService.item_info) {
          //     for(let i = 0; i < this.popupService.item_info.services.length; i++) {
          //       for(let j = 0; j < cate.services.length; j++) {
          //         if(this.popupService.item_info.services[i].id != cate.services[j].id && this.serviceInCategory(this.popupService.item_info.services[i], cate)) {
          //           return true;
          //         }
          //       }
          //     }
          //   }
          //   return false;
          // },
          searchService({target}) {
            // console.log(target.value);
            this.search = target.value;
            // this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100});
          },
          updateStaffService(staff){
            this.popupService.isOpen = false;
            this.staff = false;
            this.$emit("AddStaffService" , staff)
            this.$emit("GetTotal");
          },
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#add-more-service',
              scale: 0.8
            })
          },
          closeLoading() {
            this.$vs.loading.close('#add-more-service > .con-vs-loading');
          },
          // onChangeService(){
          //     this.openLoadingInDiv();
          //     const obj = {
          //       checkin_id: this.popupService.item_info.id,
          //       services: String(this.checkBoxService),
          //     }
          //     this.$store.dispatch("checkin/UPDATE_SERVICE",obj).then(() => {
          //       this.closeLoading();
          //       this.$vs.notify({
          //         title:'Notification',
          //         text:'Update Service Success',
          //         color:'success',
          //         position:'top-right'});
          //     })
          // },
          selectService(service) {
            // this.checkBoxService.push(service.id);
            // this.openLoadingInDiv();
              // const obj = {
              //   checkin_id: this.popupService.item_info.id,
              //   services: String(this.checkBoxService),
              // }
            //   this.$store.dispatch("checkin/UPDATE_SERVICE",obj).then(() => {
            //     this.closeLoading();
            //     this.$vs.notify({
            //       title:'Notification',
            //       text:'Update Service Success',
            //       color:'success',
            //       position:'top-right'});
            //       this.$emit('AddService');
            // })
            this.$emit('AddService', service);
          },
          // changePage(currentPage, itemsPerPage) {
          //     const obj = {
          //         page: currentPage,
          //         "per-page": itemsPerPage,
          //     }
          //     this.$store.dispatch("serviceList/GET_SERVICE_LIST", obj)
          // },
          // getMemberTypeColor(member_type) {
          //     if (member_type == "new") return "success";
          //     if (member_type == "regular") return "primary";
          //     if (member_type == "vip") return "danger";
          //     return "dark";
          // }
        },
        computed:{
          // staffListByService(){
          //   return this.$store.state.checkin.staffList;
          // },
          // staffData(){
          //   return this.$store.state.staffList.staffData;
          // },
          // serviceData(){
          //   return this.$store.state.serviceList.checkoutServiceData;
          // },
          // staffList(){
          //   return this.$store.state.staffList.staffList;
          // },
          // serviceList(){
          //   return this.$store.state.serviceList.checkoutService;
          // },
          // serviceListByCate() {
          //   return this.$store.getters['staffList/serviceList'];
          // },
          serviceListWithSearch() {
            return this.$store.getters['staffList/serviceListWithSearch'](this.search);
          },
          serviceListWithSearchAppt() {
            return this.$store.getters['service/serviceListWithSearch'](this.search);
          }
        },
        created(){
          // const obj = {
          //   page: this.currentPage,
          //   "per-page": this.itemsPerPage
          // }
          // this.$store.dispatch("serviceList/GET_SERVICE_LIST",obj).then(() => {
          //   let serviceList = this.popupService.item_info.services;
          //   if(serviceList){
          //     for(let i=0 ; i<serviceList.length;i++){
          //       this.checkBoxService.push(serviceList[i].id)
          //     }
          //   }
          // });
          this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100});
        }
    };
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
@import "@/assets/scss/custom/_variables";
.custom-col {
    width: calc(100% / 3);
}

.con-vs-popup .vs-button {
    min-width: unset !important;
}

// @media (max-width: 991px) {
//     .custom-col {
//         width: 100%;
//     }
// }
.con-vs-popup {
        &.checkout-service-popup {
            z-index: 90000 !important;
           .vs-popup {
                width: 600px;
                height: auto;
                .vs-popup--content {
                    width: auto;
                    height: calc(100vh - 200px);
                    padding: 0;
                    position: relative;

                    // max-height: calc(100vh - 200px);
                    // min-height: calc(100vh - 600px);
                    margin: 0 !important;
                    .bg-custom {
                      background: #fafafa;
                    }
                    .service-list {
                      // border-top: 0.5px solid $grey-custom;
                      // border-bottom: 0.5px solid $grey-custom;
                      // border-left: 4px solid $primary;
                      border-left-width: 5px;
                      border-left-style: solid;
                      border-left-color: $primary;
                      .service-item {
                        transition: 0.2s ease;
                        &:hover {
                          background: rgba($dark, 0.05);
                        }
                        // &:first-child {
                        //   background: rgba($primary, 0.1);
                        // }
                        .bg-select {
                          background: rgba($primary, 0.1);
                        }
                      }
                    }
                }
           }
        }
    }
.theme-dark {
  .con-vs-popup {
        &.checkout-service-popup {
          .vs-popup {
                .vs-popup--content {
                  .bg-custom {
                    background: transparent !important;
                  }
                }
          }
        }
  }
}
</style>
